import { Tooltip, TooltipProps, Box } from '@mui/material';
import React, { FC } from 'react';
import { useBoolean } from 'usehooks-ts';

interface IDisabledModeTooltipProps extends TooltipProps {
	disabled: boolean;
}

const DisabledModeTooltip: FC<IDisabledModeTooltipProps> = ({
	disabled,
	children,
	...props
}) => {
	let display = children;
	const {
		value: open,
		setTrue: setOpen,
		setFalse: setClose,
		toggle
	} = useBoolean(false);

	if (disabled) {
		display = (
			<Tooltip {...props} open={open}>
				<Box
					onMouseEnter={() => setOpen()}
					onMouseLeave={() => setClose()}
					onClick={() => toggle()}
					data-testid="disabled-tooltip-box"
				>
					{children}
				</Box>
			</Tooltip>
		);
	}

	return display;
};

export default DisabledModeTooltip;
